const state = {
  enabled: false,
  show: false,
  items: [],
  instances: [],
  currentInstance: undefined,
  activeRouter: undefined
}

const mutations = {
  enableLeftMenu (state) {
    /**
     * Включает левое меню (делает доступным, но скрытым)
     * @param {Object} state - состояние хранилища
     */
    state.enabled = true
    state.show = false
  },
  dissable (state) {
    /**
     * Отключает меню (делает недоступным и скрывает)
     * @param {Object} state - состояние хранилища
     */
    state.enabled = false
    state.show = false
  },
  show (state) {
    /**
     * Показывает меню
     * @param {Object} state - состояние хранилища
     */
    state.show = true
  },
  hide (state) {
    /**
     * Скрывает меню
     * @param {Object} state - состояние хранилища
     */
    state.show = false
  },
  toggleVisible (state) {
    /**
     * Переключает видимость меню
     * @param {Object} state - состояние хранилища
     */
    state.show = !state.show
  },
  replaceItems (state, items) {
    /**
     * Заменяет все пункты меню
     * @param {Object} state - состояние хранилища
     * @param {Array} items - новый массив пунктов меню
     */
    state.items = items
  },
  replaceInstances (state, instances) {
    /**
     * Заменяет варианты меню (инстансы)
     * @param {Object} state - состояние хранилища
     * @param {Array} instances - новый массив инстансов
     */
    state.instances = instances
  },
  addItem (state, item) {
    /**
     * Добавляет пункт в меню
     * @param {Object} state - состояние хранилища
     * @param {Object} item - объект пункта меню
     */
    state.items.push(item)
  },
  appendItems (state, items) {
    /**
     * Добавляет несколько пунктов в меню
     * @param {Object} state - состояние хранилища
     * @param {Array} items - массив пунктов меню
     */
    state.items.push(...items)
  },
  appendItem (state, item) {
    /**
     * Добавляет пункт в меню (псевдоним для addItem)
     * @param {Object} state - состояние хранилища
     * @param {Object} item - объект пункта меню
     */
    state.items.push(item)
  },
  selectInstance (state, name) {
    /**
     * Выбирает текущий инстанс меню
     * @param {Object} state - состояние хранилища
     * @param {string} name - имя инстанса
     */
    state.currentInstance = name
  },
  activeRouterChange (state, activeRouterName) {
    /**
     * Обновляет активный маршрут
     * @param {Object} state - состояние хранилища
     * @param {string} activeRouterName - имя активного маршрута
     */
    state.activeRouter = activeRouterName
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
